/**
 * Append a one-shot cache-busting query param to a recovery URL.
 *
 * A plain `location.reload()` revalidates index.html in normal browsers (we serve
 * it `Cache-Control: no-cache`), but the B24 DESKTOP webview can still hand back a
 * CACHED index.html on the first reload — which re-references the very chunk hashes
 * that just 404'd, so the reload "doesn't take". A unique query forces a fresh
 * document GET. Harmless and transient: the SPA router ignores `_emr`, and it's
 * only ever added on a post-deploy recovery. The hash is preserved (placed after
 * the query) so route state isn't lost.
 *
 * Lives in its own module because BOTH the automatic recovery
 * (`installChunkReloadGuard`) and the user-driven one (`useAppUpdate`) need it,
 * and those two already reference each other.
 */
export function withCacheBust(url: string): string {
  const hashIdx = url.indexOf('#')
  const hash = hashIdx === -1 ? '' : url.slice(hashIdx)
  const base = hashIdx === -1 ? url : url.slice(0, hashIdx)
  const sep = base.indexOf('?') === -1 ? '?' : '&'
  return `${base}${sep}_emr=${Date.now()}${hash}`
}
